import React from 'react';
import { Send, Loader2 } from 'lucide-react';

const ContactForm = ({ formData, loading, handleChange, handleSubmit, isRobot, setIsRobot }) => {
  return (
    <div className="bg-white rounded-3xl p-8 lg:p-10">
      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label htmlFor="firstName" className="block text-sm font-semibold text-[#2C2C2A] mb-2">
              First Name *
            </label>
            <input
              type="text"
              id="firstName"
              name="firstName"
              data-testid="contact-firstname"
              required
              value={formData.firstName}
              onChange={handleChange}
              className="w-full px-4 py-3 border border-[#E4E1D8] rounded-xl focus:ring-2 focus:ring-[#0F6E56] focus:border-transparent transition-all text-[#2C2C2A]"
            />
          </div>
          <div>
            <label htmlFor="lastName" className="block text-sm font-semibold text-[#2C2C2A] mb-2">
              Last Name *
            </label>
            <input
              type="text"
              id="lastName"
              name="lastName"
              data-testid="contact-lastname"
              required
              value={formData.lastName}
              onChange={handleChange}
              className="w-full px-4 py-3 border border-[#E4E1D8] rounded-xl focus:ring-2 focus:ring-[#0F6E56] focus:border-transparent transition-all text-[#2C2C2A]"
            />
          </div>
        </div>

        <div>
          <label htmlFor="email" className="block text-sm font-semibold text-[#2C2C2A] mb-2">
            Email Address *
          </label>
          <input
            type="email"
            id="email"
            name="email"
            data-testid="contact-email"
            required
            value={formData.email}
            onChange={handleChange}
            className="w-full px-4 py-3 border border-[#E4E1D8] rounded-xl focus:ring-2 focus:ring-[#0F6E56] focus:border-transparent transition-all text-[#2C2C2A]"
          />
        </div>

        <div>
          <label htmlFor="phone" className="block text-sm font-semibold text-[#2C2C2A] mb-2">
            Phone Number *
          </label>
          <input
            type="tel"
            id="phone"
            name="phone"
            data-testid="contact-phone"
            required
            value={formData.phone}
            onChange={handleChange}
            className="w-full px-4 py-3 border border-[#E4E1D8] rounded-xl focus:ring-2 focus:ring-[#0F6E56] focus:border-transparent transition-all text-[#2C2C2A]"
          />
        </div>

        <div>
          <label htmlFor="subject" className="block text-sm font-semibold text-[#2C2C2A] mb-2">
            Subject *
          </label>
          <input
            type="text"
            id="subject"
            name="subject"
            data-testid="contact-subject"
            required
            value={formData.subject}
            onChange={handleChange}
            className="w-full px-4 py-3 border border-[#E4E1D8] rounded-xl focus:ring-2 focus:ring-[#0F6E56] focus:border-transparent transition-all text-[#2C2C2A]"
          />
        </div>

        <div>
          <label htmlFor="message" className="block text-sm font-semibold text-[#2C2C2A] mb-2">
            Message *
          </label>
          <textarea
            id="message"
            name="message"
            data-testid="contact-message"
            rows="4"
            required
            value={formData.message}
            onChange={handleChange}
            className="w-full px-4 py-3 border border-[#E4E1D8] rounded-xl focus:ring-2 focus:ring-[#0F6E56] focus:border-transparent transition-all resize-none text-[#2C2C2A]"
          ></textarea>
        </div>

        {/* Captcha */}
        <div className="flex items-center space-x-3 p-4 border-2 border-[#E4E1D8] rounded-xl bg-[#F1EFE8]">
          <input
            type="checkbox"
            id="robotCheck"
            data-testid="contact-robot-check"
            checked={!isRobot}
            onChange={(e) => setIsRobot(!e.target.checked)}
            className="w-5 h-5 text-[#0F6E56] border-[#E4E1D8] rounded focus:ring-[#0F6E56]"
          />
          <label htmlFor="robotCheck" className="text-[#2C2C2A] font-medium cursor-pointer select-none">
            I'm not a robot
          </label>
        </div>

        <button
          type="submit"
          data-testid="contact-submit"
          disabled={loading || isRobot}
          className="w-full flex items-center justify-center space-x-2 px-8 py-4 bg-[#0F6E56] text-white rounded-full hover:bg-[#0d5c48] transition-all duration-300 font-semibold text-lg shadow-lg hover:shadow-xl transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
        >
          {loading ? (
            <>
              <Loader2 className="w-5 h-5 animate-spin" />
              <span>Sending...</span>
            </>
          ) : (
            <>
              <span>Send Message</span>
              <Send className="w-5 h-5" />
            </>
          )}
        </button>
      </form>
    </div>
  );
};

export default ContactForm;